import React from "react"
import { Alert, Modal, CardBody, Button, Card, Input } from "reactstrap"
import NotificationAlert from "react-notification-alert"
import { connect } from "react-redux"
import readXlsxFile from "read-excel-file"
import $ from "jquery"
import reduxHelper from "../../../../helper/index.js"
import Select from "react-dropdown-select"

class BulkUpdateUsersXlsx extends React.Component {
  constructor(props) {
    super(props)
    this.setStateTop = this.props.setState
    this.state = {
      rowsList: [],
      importError: "",
      erroXLSX: "",
      verificado: false,
      verifyingData: false,
      applying: false,
      applyingProgress: { current: 0, total: 0 },
      replaceClassrooms: true,
      selectedRowsForTurma: new Set(),
      bulkReplaceTurmaName: "",
      bulkNewClassId: "",
      manualReplaceByTurmaName: {},
      manualTypeByTurmaName: {}
    }
    this.checkXlsx = this.checkXlsx.bind(this)
    this.reset = this.reset.bind(this)
    this.checkXlsxServer = this.checkXlsxServer.bind(this)
    this.applyUpdates = this.applyUpdates.bind(this)
    this.helper = new reduxHelper(this.props)
    this.removeLine = this.removeLine.bind(this)
    this.changeValue = this.changeValue.bind(this)
    this.normalizeTurmaName = this.normalizeTurmaName.bind(this)
    this.selectAllWithSameTurmaError = this.selectAllWithSameTurmaError.bind(this)
    this.selectAllWithTurmaErrors = this.selectAllWithTurmaErrors.bind(this)
    this.clearTurmaSelection = this.clearTurmaSelection.bind(this)
    this.applyBulkClassChange = this.applyBulkClassChange.bind(this)
    this.applySuggestionForMissingName = this.applySuggestionForMissingName.bind(this)
  }

  changeValue(index, field, value) {
    const rowsList = [...this.state.rowsList]
    if (!rowsList[index]) return
    rowsList[index] = { ...rowsList[index], [field]: value }
    this.setState({ rowsList, verificado: false })
  }

  normalizeTurmaName(str) {
    if (str == null || typeof str !== "string") return ""
    return str
      .toLowerCase()
      .trim()
      .normalize("NFD")
      .replace(/\p{Diacritic}/gu, "")
  }

  findSimilarClassrooms(typedName, classRoomList) {
    if (!typedName || !Array.isArray(classRoomList) || classRoomList.length === 0) return []
    const normTyped = this.normalizeTurmaName(typedName)
    if (!normTyped) return []
    const scored = classRoomList.map(c => {
      const normClass = this.normalizeTurmaName(c.name)
      let score = 0
      if (normClass === normTyped) return { c, score: 100 }
      if (normClass.includes(normTyped)) score += 60
      else if (normTyped.includes(normClass)) score += 50
      const minLen = Math.min(normTyped.length, normClass.length)
      let prefix = 0
      for (let i = 0; i < minLen && normTyped[i] === normClass[i]; i++) prefix++
      score += (prefix / Math.max(normTyped.length, normClass.length, 1)) * 30
      const wordsTyped = normTyped.split(/\s+/).filter(Boolean)
      const wordsClass = normClass.split(/\s+/).filter(Boolean)
      const commonWords = wordsTyped.filter(w => wordsClass.some(wc => wc.includes(w) || w.includes(wc))).length
      score += (commonWords / Math.max(wordsTyped.length, 1)) * 20
      return { c, score }
    })
    scored.sort((a, b) => b.score - a.score)
    return scored.filter(x => x.score > 15).slice(0, 5).map(x => ({ id: x.c.id, name: x.c.name }))
  }

  buildPayloadRows() {
    return this.state.rowsList.map(row => {
      const out = {
        email: (row.email || "").toString().trim() || undefined,
        username: (row.username || "").toString().trim() || undefined,
        password: (row.password || "").toString().trim() || undefined,
        blocked: row.blocked,
        blockedQRcode: row.blockedQRcode,
        blockedReason: (row.blockedReason || "").toString().trim() || undefined
      }
      if (row.id != null && row.id !== "" && !isNaN(parseInt(row.id, 10)) && parseInt(row.id, 10) > 0) {
        out.id = parseInt(row.id, 10)
      }
      if (out.email === "") delete out.email
      if (out.username === "") delete out.username
      if (out.password === "") delete out.password
      if (out.blockedReason === "") delete out.blockedReason
      const selectedClassRooms = row.classRoom && Array.isArray(row.classRoom) ? row.classRoom : []
      const classRooms = selectedClassRooms
        .filter(c => c && c.id != null && c.id !== "")
        .map(c => ({ id: c.id, type: parseInt(c.type, 10) || 4 }))
      if (classRooms.length > 0) out.classRooms = classRooms
      return out
    }).filter(r => r.id != null || r.email || r.username)
  }

  async checkXlsxServer() {
    const payload = this.buildPayloadRows()
    if (payload.length === 0) {
      await this.setState({ erroXLSX: "Nenhum usuário para verificar. Informe email ou username em cada linha." })
      return
    }
    this.setState({ verifyingData: true, erroXLSX: "" })
    try {
      const data = await this.helper.user().userCheckXlsxUpdate(payload)
      if (!data) {
        await this.setState({ erroXLSX: "Erro de conexão com o servidor. Tente novamente." })
        return
      }
      if (parseInt(data.status, 10) === 200) {
        await this.setState({ erroXLSX: "", verificado: true })
      } else {
        const msg = (data.data && data.data.data && data.data.data.msg) || (data.data && data.data.msg) || "Erro ao validar dados."
        await this.setState({ erroXLSX: msg })
      }
    } finally {
      this.setState({ verifyingData: false })
    }
  }

  async applyUpdates() {
    const payload = this.buildPayloadRows()
    if (payload.length === 0) return
    const total = payload.length
    this.setState({ applying: true, applyingProgress: { current: 0, total } })
    try {
      const data = await this.helper.user().userBulkUpdate({ list: payload, replaceClassrooms: this.state.replaceClassrooms })
      if (!data || parseInt(data.status, 10) !== 200) {
        const msg = (data && data.data && data.data.data && data.data.data.msg) || (data && data.data && data.data.msg) || "Erro ao aplicar atualizações."
        this.refs.notificationAlert.notificationAlert({
          place: "tr",
          message: (<div className="alert-text"><span className="alert-title" data-notify="title">Erro</span><span data-notify="message">{msg}</span></div>),
          type: "danger",
          icon: "fas fa-exclamation",
          autoDismiss: 7
        })
        return
      }
      const result = data.data || {}
      this.setStateTop({ openModalBulkUpdateUsers: false })
      this.reset()
      if (this.props.getAllUsers) this.props.getAllUsers()
      const errors = result.errors || []
      const updated = result.updated || 0
      if (errors.length > 0) {
        this.refs.notificationAlert.notificationAlert({
          place: "tr",
          message: (
            <div className="alert-text">
              <span className="alert-title" data-notify="title">Atualização em massa</span>
              <span data-notify="message">
                {updated} atualizado(s). {errors.length} erro(s): {errors.slice(0, 3).map(e => `Linha ${e.line}: ${e.msg}`).join("; ")}{errors.length > 3 ? "..." : ""}
              </span>
            </div>
          ),
          type: "warning",
          icon: "fas fa-exclamation",
          autoDismiss: 10
        })
      } else {
        this.refs.notificationAlert.notificationAlert({
          place: "tr",
          message: (
            <div className="alert-text">
              <span className="alert-title" data-notify="title">{this.props.translate["sucesso"]}!</span>
              <span data-notify="message">{this.props.translate["a_importacao_foi_realizada"] || "Atualização em massa concluída."}</span>
            </div>
          ),
          type: "success",
          icon: "fas fa-check",
          autoDismiss: 5
        })
      }
    } finally {
      this.setState({ applying: false, applyingProgress: { current: 0, total: 0 } })
    }
  }

  removeLine(index) {
    const rowsList = [...this.state.rowsList]
    rowsList.splice(index, 1)
    this.setState({ rowsList, verificado: false })
    if (rowsList.length > 0) this.checkXlsxServer()
  }

  async checkXlsx() {
    const fileInput = $("#input_xlsx_bulk_update")[0]
    fileInput.nextElementSibling && (fileInput.nextElementSibling.textContent = fileInput.files[0].name)
    const file = fileInput.files[0]
    if (!file) {
      this.setState({ importError: this.props.translate["selecione_o_arquivo"] || "Selecione o arquivo." })
      return false
    }
    let rows = null
    const isCsv = file.name.toLowerCase().endsWith(".csv")
    try {
      if (isCsv) {
        const text = await new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onload = () => resolve(reader.result)
          reader.onerror = reject
          reader.readAsText(file, "UTF-8")
        })
        const lines = text.split(/\r?\n/).filter(Boolean)
        rows = lines.map(line => {
          const result = []
          let current = ""
          let inQuotes = false
          for (let i = 0; i < line.length; i++) {
            const c = line[i]
            if (c === '"') { inQuotes = !inQuotes; continue }
            if (!inQuotes && (c === "," || c === ";")) { result.push(current.trim()); current = ""; continue }
            current += c
          }
          result.push(current.trim())
          return result
        })
      } else {
        await readXlsxFile(file).then(r => { rows = r })
      }
    } catch (error) {
      this.setState({ importError: this.props.translate["nao_foi_possivel_abrir_o_arquivo"] || "Não foi possível abrir o arquivo." })
      return false
    }
    if (!rows || rows.length <= 1) {
      this.setState({ importError: this.props.translate["o_arquivo_enviado_esta_vazio"] || "O arquivo está vazio ou sem linhas de dados." })
      return false
    }
    const passBlocked = ["sim", "yes", "s", "y", "1", "true"]
    const header0 = (rows[0] && rows[0][0] != null ? rows[0][0] : "").toString().trim().toLowerCase()
    const hasIdColumn = header0 === "id"
    const parsed = []
    for (let i = 1; i < rows.length; i++) {
      const r = rows[i]
      let idVal = null
      let email, username, password, blockedIdx, blockedQRIdx, reasonIdx, turmasIdx
      if (hasIdColumn) {
        const rawId = (r[0] != null ? r[0] : "").toString().trim()
        const numId = parseInt(rawId, 10)
        idVal = rawId && !isNaN(numId) && numId > 0 ? numId : null
        email = (r[1] != null ? r[1] : "").toString().trim()
        username = (r[2] != null ? r[2] : "").toString().trim()
        password = (r[5] != null ? r[5] : "").toString().trim()
        blockedIdx = 6
        blockedQRIdx = 7
        reasonIdx = 8
        turmasIdx = 9
      } else {
        email = (r[0] != null ? r[0] : "").toString().trim()
        username = (r[1] != null ? r[1] : "").toString().trim()
        password = (r[2] != null ? r[2] : "").toString().trim()
        blockedIdx = 3
        blockedQRIdx = 4
        reasonIdx = 5
        turmasIdx = 6
      }
      if (!idVal && !email && !username) continue
      const blockedRaw = (r[blockedIdx] != null ? r[blockedIdx] : "").toString().trim().toLowerCase()
      const blocked = blockedRaw === "" ? null : (passBlocked.indexOf(blockedRaw) !== -1 ? 1 : 0)
      const blockedQRRaw = (r[blockedQRIdx] != null ? r[blockedQRIdx] : "").toString().trim().toLowerCase()
      const blockedQRcode = blockedQRRaw === "" ? null : (passBlocked.indexOf(blockedQRRaw) !== -1 ? 1 : 0)
      const blockedReason = (r[reasonIdx] != null ? r[reasonIdx] : "").toString().trim()
      const classRoomNames = (r[turmasIdx] != null ? r[turmasIdx] : "").toString().trim()
      const classRoomTypeRaw = (r[turmasIdx + 1] != null ? r[turmasIdx + 1] : "").toString().trim()
      const classRoomList = this.props.state.classRoom || []
      const classRooms = (this.props.state.classRoom || []).map(c => ({ ...c, type: c.type || "4" }))
      const classRoom = []
      const classRoomNamesNotFound = []
      const permitions = (window.app && window.app.state && window.app.state.permitions) ? window.app.state.permitions : []
      const tiposLista = classRoomTypeRaw.split(/[,;]/).map(s => s.trim())
      if (classRoomNames) {
        const nomes = classRoomNames.split(/[,;]/).map(s => s.trim()).filter(Boolean)
        for (let nc = 0; nc < nomes.length; nc++) {
          const nomeOriginal = nomes[nc]
          const nomeDigitado = this.normalizeTurmaName(nomeOriginal)
          if (!nomeDigitado) continue
          // Resolve tipo: lê da coluna de tipos (posição nc), busca em permitions pelo nome ou usa "4" (aluno)
          let tipoFinal = "4"
          const tipoRaw = tiposLista[nc] ? tiposLista[nc] : ""
          if (tipoRaw) {
            const tipoNorm = this.normalizeTurmaName(tipoRaw)
            const found2 = permitions.find(p => this.normalizeTurmaName(p.name) === tipoNorm)
            if (found2) tipoFinal = String(found2.id)
            else if (!isNaN(parseInt(tipoRaw, 10))) tipoFinal = String(parseInt(tipoRaw, 10))
          }
          let found = false
          for (let j = 0; j < classRoomList.length; j++) {
            if (this.normalizeTurmaName(classRoomList[j].name) === nomeDigitado) {
              classRooms[j].type = tipoFinal
              classRoom.push({ id: classRoomList[j].id, name: classRoomList[j].name, type: tipoFinal })
              found = true
              break
            }
          }
          if (!found) {
            const suggestions = this.findSimilarClassrooms(nomeOriginal, classRoomList)
            classRoomNamesNotFound.push({ name: nomeOriginal, suggestions })
          }
        }
      }
      parsed.push({
        id: idVal,
        email,
        username,
        password,
        blocked,
        blockedQRcode,
        blockedReason,
        classRoom,
        classRoomNamesNotFound,
        classRooms: JSON.parse(JSON.stringify(classRooms))
      })
    }
    if (parsed.length === 0) {
      this.setState({ importError: "Nenhuma linha válida. Informe ao menos ID, email ou username em cada linha." })
      return false
    }
    await this.setState({ rowsList: parsed, importError: "", verificado: false })
    this.checkXlsxServer()
  }

  selectAllWithSameTurmaError(turmaName) {
    const selected = new Set(this.state.selectedRowsForTurma)
    this.state.rowsList.forEach((row, i) => {
      if (row.classRoomNamesNotFound && row.classRoomNamesNotFound.some(item => item.name === turmaName)) {
        selected.add(i)
      }
    })
    this.setState({ selectedRowsForTurma: selected, bulkReplaceTurmaName: turmaName })
  }

  selectAllWithTurmaErrors() {
    const selected = new Set()
    this.state.rowsList.forEach((row, i) => {
      if (row.classRoomNamesNotFound && row.classRoomNamesNotFound.length > 0) {
        selected.add(i)
      }
    })
    const firstIdx = [...selected][0]
    const firstNames = firstIdx !== undefined ? (this.state.rowsList[firstIdx].classRoomNamesNotFound || []) : []
    this.setState({ selectedRowsForTurma: selected, bulkReplaceTurmaName: firstNames.length === 1 ? firstNames[0].name : "" })
  }

  clearTurmaSelection() {
    this.setState({ selectedRowsForTurma: new Set(), bulkReplaceTurmaName: "", bulkNewClassId: "" })
  }

  applyBulkClassChange() {
    const { selectedRowsForTurma, bulkReplaceTurmaName, bulkNewClassId, rowsList } = this.state
    const nameToReplace = bulkReplaceTurmaName || (this.getUniqueMissingNamesInSelection().length === 1 ? this.getUniqueMissingNamesInSelection()[0] : "")
    if (!nameToReplace || selectedRowsForTurma.size === 0 || !bulkNewClassId) return
    const newClass = (this.props.state.classRoom || []).find(c => String(c.id) === String(bulkNewClassId))
    if (!newClass) return
    const resolvedType = this.state.manualTypeByTurmaName[nameToReplace] || "4"
    const newClassObj = { id: newClass.id, name: newClass.name, type: resolvedType }
    const updated = rowsList.map((row, index) => {
      if (!selectedRowsForTurma.has(index) || !row.classRoomNamesNotFound) return row
      const idx = row.classRoomNamesNotFound.findIndex(item => item.name === nameToReplace)
      if (idx === -1) return row
      const newNotFound = [...row.classRoomNamesNotFound]
      newNotFound.splice(idx, 1)
      const newClassRoom = [...(row.classRoom || []), newClassObj]
      return { ...row, classRoomNamesNotFound: newNotFound, classRoom: newClassRoom }
    })
    this.setState({ rowsList: updated, selectedRowsForTurma: new Set(), bulkReplaceTurmaName: "", bulkNewClassId: "", verificado: false })
  }

  getUniqueMissingNamesInSelection() {
    const names = new Set()
    this.state.selectedRowsForTurma.forEach(index => {
      const row = this.state.rowsList[index]
      if (row.classRoomNamesNotFound) row.classRoomNamesNotFound.forEach(item => names.add(item.name))
    })
    return [...names]
  }

  getTurmasComErro() {
    const names = new Set()
    this.state.rowsList.forEach(row => {
      if (row.classRoomNamesNotFound) row.classRoomNamesNotFound.forEach(item => names.add(item.name))
    })
    return [...names]
  }

  getSuggestionsForMissingName(turmaName) {
    for (let i = 0; i < this.state.rowsList.length; i++) {
      const row = this.state.rowsList[i]
      if (!row.classRoomNamesNotFound) continue
      const item = row.classRoomNamesNotFound.find(x => x.name === turmaName)
      if (item && item.suggestions && item.suggestions.length > 0) return item.suggestions
    }
    return []
  }

  applySuggestionForMissingName(turmaName, newClassId, type) {
    const newClass = (this.props.state.classRoom || []).find(c => String(c.id) === String(newClassId))
    if (!newClass) return
    const resolvedType = type || this.state.manualTypeByTurmaName[turmaName] || "4"
    const newClassObj = { id: newClass.id, name: newClass.name, type: resolvedType }
    const updated = this.state.rowsList.map((row) => {
      if (!row.classRoomNamesNotFound) return row
      const idx = row.classRoomNamesNotFound.findIndex(item => item.name === turmaName)
      if (idx === -1) return row
      const newNotFound = [...row.classRoomNamesNotFound]
      newNotFound.splice(idx, 1)
      const newClassRoom = [...(row.classRoom || []), newClassObj]
      // Sincroniza o type no classRooms (options) da row para o dropdown refletir corretamente
      const newClassRooms = (row.classRooms || []).map(cr =>
        String(cr.id) === String(newClass.id) ? { ...cr, type: resolvedType } : cr
      )
      return { ...row, classRoomNamesNotFound: newNotFound, classRoom: newClassRoom, classRooms: newClassRooms }
    })
    this.setState({ rowsList: updated, verificado: false })
  }

  renderErrorClassPanel() {
    const turmasComErro = this.getTurmasComErro()
    const totalLinhasComErro = this.state.rowsList.filter(row => row.classRoomNamesNotFound && row.classRoomNamesNotFound.length > 0).length
    if (turmasComErro.length === 0) return null

    const classRoomList = this.props.state.classRoom || []
    const { manualReplaceByTurmaName, manualTypeByTurmaName } = this.state
    const txt = (key, fallback) => this.props.translate[key] || fallback
    const permitions = (window.app && window.app.state && window.app.state.permitions && window.app.state.permitions.length > 0)
      ? window.app.state.permitions
      : [{ id: "3", name: "Professor" }, { id: "4", name: "Aluno" }, { id: "6", name: "Diretor" }]

    return (
      <Alert color="warning" className="mb-3">
        <div className="d-flex align-items-center mb-3">
          <i className="fas fa-exclamation-triangle mr-2"></i>
          <strong>
            {txt("turmas_nao_encontradas", "Turmas não encontradas")}: {turmasComErro.length} {txt("nome_s_na_planilha", "nome(s) na planilha")} em {totalLinhasComErro} {txt("linha_s", "linha(s)")}
          </strong>
        </div>
        <p className="small text-muted mb-2">
          {txt("substituir_cada_uma_por", "Para cada nome, escolha a turma correta e o tipo de acesso que o usuário terá nela.")}
        </p>
        <div className="table-responsive" style={{ maxHeight: "360px", overflowY: "auto" }}>
          <table className="table table-sm table-bordered mb-0 bg-white">
            <thead className="thead-light" style={{ position: "sticky", top: 0, zIndex: 1 }}>
              <tr>
                <th style={{ minWidth: "130px" }}>{txt("nome_na_planilha", "Nome na planilha")}</th>
                <th style={{ width: "60px", textAlign: "center" }}>{txt("linha_s", "Linhas")}</th>
                <th>Vai para qual turma</th>
                <th style={{ width: "110px" }}>Como</th>
                <th style={{ width: "70px" }}></th>
              </tr>
            </thead>
            <tbody>
              {turmasComErro.map((turma, i) => {
                const count = this.state.rowsList.filter(row => row.classRoomNamesNotFound && row.classRoomNamesNotFound.some(item => item.name === turma)).length
                const suggestions = this.getSuggestionsForMissingName(turma)
                const selectedId = manualReplaceByTurmaName[turma] || ""
                const selectedType = manualTypeByTurmaName[turma] || "4"
                return (
                  <tr key={i}>
                    <td className="align-middle">
                      <span className="text-dark font-weight-medium">&quot;{turma}&quot;</span>
                    </td>
                    <td className="align-middle text-center">
                      <span className="badge badge-warning">{count}</span>
                    </td>
                    <td className="align-middle">
                      {suggestions.length > 0 && (
                        <div className="mb-1">
                          {suggestions.map((sug, j) => (
                            <Button
                              key={j}
                              size="sm"
                              color="primary"
                              outline
                              className="mr-1 mb-1"
                              style={{ fontSize: "0.72rem" }}
                              onClick={() => {
                                this.applySuggestionForMissingName(turma, sug.id, selectedType)
                                const next = { ...this.state.manualTypeByTurmaName }
                                delete next[turma]
                                this.setState({ manualTypeByTurmaName: next })
                              }}
                            >
                              {sug.name}
                            </Button>
                          ))}
                          <small className="text-muted">{txt("ou_escolher", "ou escolha:")}</small>
                        </div>
                      )}
                      <Input
                        type="select"
                        bsSize="sm"
                        value={selectedId}
                        onChange={e => this.setState({ manualReplaceByTurmaName: { ...manualReplaceByTurmaName, [turma]: e.target.value } })}
                        style={{ maxWidth: "100%" }}
                      >
                        <option value="">{txt("selecione_a_turma", "Selecione a turma...")}</option>
                        {classRoomList.map((c, k) => (
                          <option key={k} value={c.id}>{c.name}</option>
                        ))}
                      </Input>
                    </td>
                    <td className="align-middle">
                      <Input
                        type="select"
                        bsSize="sm"
                        value={selectedType}
                        onChange={e => this.setState({ manualTypeByTurmaName: { ...manualTypeByTurmaName, [turma]: e.target.value } })}
                      >
                        {permitions.map((p, pi) => (
                          <option key={pi} value={p.id}>{p.name}</option>
                        ))}
                      </Input>
                    </td>
                    <td className="align-middle text-center">
                      <Button
                        size="sm"
                        color="success"
                        disabled={!selectedId}
                        onClick={() => {
                          if (selectedId) {
                            this.applySuggestionForMissingName(turma, selectedId, selectedType)
                            const nextId = { ...this.state.manualReplaceByTurmaName }
                            const nextType = { ...this.state.manualTypeByTurmaName }
                            delete nextId[turma]
                            delete nextType[turma]
                            this.setState({ manualReplaceByTurmaName: nextId, manualTypeByTurmaName: nextType })
                          }
                        }}
                      >
                        {txt("aplicar", "Aplicar")}
                      </Button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </Alert>
    )
  }

  reset() {
    this.setState({
      rowsList: [],
      verificado: false,
      erroXLSX: "",
      verifyingData: false,
      applying: false,
      applyingProgress: { current: 0, total: 0 },
      replaceClassrooms: true,
      selectedRowsForTurma: new Set(),
      bulkReplaceTurmaName: "",
      bulkNewClassId: "",
      manualReplaceByTurmaName: {},
      manualTypeByTurmaName: {}
    })
  }

  render() {
    const isLoading = this.state.verifyingData || this.state.applying
    const loadingTitle = this.state.applying ? "Aplicando atualizações..." : "Verificando dados..."
    const loadingProgress = this.state.applying ? this.state.applyingProgress : { current: 0, total: 0 }

    return (
      <React.Fragment>
        <div className="rna-wrapper">
          <NotificationAlert ref="notificationAlert" />
        </div>
        {isLoading && (
          <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.35)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1060 }}>
            <div style={{ background: "#fff", borderRadius: "12px", padding: "2rem 2.5rem", boxShadow: "0 10px 40px rgba(0,0,0,0.2)", minWidth: "280px", display: "flex", flexDirection: "column", alignItems: "center" }}>
              <div style={{ marginBottom: "1rem" }}>
                <div className="spinner-border text-primary" role="status" style={{ width: "3rem", height: "3rem" }}>
                  <span className="sr-only">Carregando...</span>
                </div>
              </div>
              <p className="mb-1 font-weight-bold text-dark">{loadingTitle}</p>
              {this.state.applying && (
                <p className="text-muted small mb-0">{loadingProgress.current} de {loadingProgress.total}</p>
              )}
            </div>
          </div>
        )}
        <Modal className="modal-dialog-centered" style={this.state.rowsList.length > 0 ? { maxWidth: "98%" } : {}} isOpen={this.props.state.openModalBulkUpdateUsers}>
          <div className="modal-body p-0">
            <Card className="bg-secondary border-0 mb-0">
              <div className="modal-header">
                <h6 className="modal-title">{this.props.translate["atualizar_por_planilha"] || "Atualizar usuários por planilha"}</h6>
                <button type="button" className="close" onClick={() => { this.setStateTop({ openModalBulkUpdateUsers: false }); this.reset(); }}>
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <CardBody>
                {this.state.importError !== "" && (
                  <Alert color="danger"><strong>{this.props.translate["ops"] || "Ops"}!</strong> {this.state.importError}</Alert>
                )}
                {this.state.rowsList.length === 0 && (
                  <React.Fragment>
                    <center><font>{this.props.translate["selecione_o_arquivo"] || "Selecione o arquivo"}:</font></center>
                    <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap", justifyContent: "center", marginTop: "0.5rem" }}>
                      <div className="custom-file form-control-sm" style={{ maxWidth: "300px" }}>
                        <input onChange={() => this.checkXlsx()} className="custom-file-input" id="input_xlsx_bulk_update" type="file" accept=".xlsx,.xls,.csv" />
                        <label className="custom-file-label" htmlFor="input_xlsx_bulk_update">{this.props.translate["selecionar_arquivo"] || "Selecionar arquivo"}</label>
                      </div>
                    </div>
                    <div className="text-center mt-3">
                      <small className="text-muted d-block mb-1"><strong>Como funciona:</strong> Use o <strong>ID</strong> do usuário para identificar quem editar (a planilha do &quot;Exportar alunos&quot; já vem com o ID). Com o ID preenchido, você pode alterar <strong>E-mail</strong>, <strong>Usuário</strong>, senha, bloqueio e turmas. Deixe em branco o que não quiser mudar.</small>
                      <small className="text-muted d-block mb-2">Colunas: ID (opcional) | Email | Username | Nome | Sobrenome | Senha | Bloqueado | Bloqueio QR | Motivo bloqueio | Turmas | Tipo nas turmas (opcional, ex: Professor, Aluno, Diretor)</small>
                      <a target="_blank" rel="noopener noreferrer" href="/planilha/Template atualizacao usuarios.csv" download>
                        <Button color="default" type="button" size="sm"><i className="fas fa-file-download mr-1"></i>{this.props.translate["baixar_template"] || "Baixar modelo"}</Button>
                      </a>
                    </div>
                  </React.Fragment>
                )}
                {this.state.rowsList.length !== 0 && (
                  <React.Fragment>
                    {this.state.erroXLSX !== "" && <Alert color="danger"><strong>{this.props.translate["ops"]}!</strong> {this.state.erroXLSX}</Alert>}
                    {this.state.erroXLSX === "" && this.state.verificado && (
                      <Alert color="success"><strong><i className="fas fa-check"></i></strong> {this.props.translate["verificar_dados_atualizacao"] || "Dados válidos para atualização."}</Alert>
                    )}
                    <p className="small text-muted mb-2">O <strong>ID</strong> identifica quem será atualizado. Com o ID preenchido, você pode alterar também <strong>E-mail</strong> e <strong>Usuário</strong>. Deixe em branco o que não quiser mudar.</p>
                    <div className="mb-3">
                      <small className="text-muted d-block mb-1">{this.props.translate["ao_atualizar_turmas"] || "Ao atualizar turmas"}:</small>
                      <div className="d-flex flex-wrap gap-3">
                        <label className="d-flex align-items-center mb-0">
                          <input type="radio" checked={this.state.replaceClassrooms === true} onChange={() => this.setState({ replaceClassrooms: true })} className="mr-2" />
                          {this.props.translate["substituir_turmas"] || "Substituir (remover das antigas e deixar só as da planilha)"}
                        </label>
                        <label className="d-flex align-items-center mb-0">
                          <input type="radio" checked={this.state.replaceClassrooms === false} onChange={() => this.setState({ replaceClassrooms: false })} className="mr-2" />
                          {this.props.translate["adicionar_turmas"] || "Adicionar (manter atuais e adicionar as da planilha)"}
                        </label>
                      </div>
                    </div>
                    {this.renderErrorClassPanel()}
                    <div className="table-responsive div_tab_importxlsx">
                      <table className="align-items-center table-flush table table_importXLXS">
                        <thead className="thead-light">
                          <tr>
                            <th style={{ width: "40px" }}>#</th>
                            <th style={{ width: "60px" }}>ID <small className="text-muted">({this.props.translate["quem_editar"] || "quem editar"})</small></th>
                            <th>{this.props.translate["email"] || "E-mail"} <small className="text-muted">({this.props.translate["pode_editar"] || "pode editar"})</small></th>
                            <th>{this.props.translate["usuario"] || "Usuário"} <small className="text-muted">({this.props.translate["pode_editar"] || "pode editar"})</small></th>
                            <th style={{ width: "90px" }}>Senha</th>
                            <th style={{ width: "80px" }}>Bloqueado</th>
                            <th style={{ width: "80px" }}>Bloq. QR</th>
                            <th>Motivo bloqueio</th>
                            <th>Turmas</th>
                            <th style={{ width: "40px" }}></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.rowsList.map((row, index) => (
                            <tr key={`bulk_row_${index}`}>
                              <td>{index + 1}</td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control form-control-sm border-0"
                                  placeholder="ID"
                                  value={row.id != null ? row.id : ""}
                                  onChange={e => {
                                    const v = e.target.value.trim()
                                    this.changeValue(index, "id", v === "" ? null : (isNaN(parseInt(v, 10)) ? row.id : parseInt(v, 10)))
                                  }}
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control form-control-sm border-0"
                                  placeholder="email@exemplo.com"
                                  value={row.email || ""}
                                  onChange={e => this.changeValue(index, "email", e.target.value)}
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control form-control-sm border-0"
                                  placeholder="usuário"
                                  value={row.username || ""}
                                  onChange={e => this.changeValue(index, "username", e.target.value)}
                                />
                              </td>
                              <td>
                                <input
                                  type="password"
                                  className="form-control form-control-sm border-0"
                                  placeholder="nova senha"
                                  value={row.password || ""}
                                  onChange={e => this.changeValue(index, "password", e.target.value)}
                                />
                              </td>
                              <td>
                                <select
                                  className="form-control form-control-sm border-0"
                                  value={row.blocked === 1 ? "1" : "0"}
                                  onChange={e => this.changeValue(index, "blocked", parseInt(e.target.value, 10))}
                                >
                                  <option value="0">Não</option>
                                  <option value="1">Sim</option>
                                </select>
                              </td>
                              <td>
                                <select
                                  className="form-control form-control-sm border-0"
                                  value={row.blockedQRcode === 1 ? "1" : "0"}
                                  onChange={e => this.changeValue(index, "blockedQRcode", parseInt(e.target.value, 10))}
                                >
                                  <option value="0">Não</option>
                                  <option value="1">Sim</option>
                                </select>
                              </td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control form-control-sm border-0"
                                  placeholder="Motivo (se bloqueado)"
                                  value={row.blockedReason || ""}
                                  onChange={e => this.changeValue(index, "blockedReason", e.target.value)}
                                />
                              </td>
                              <td>
                                <div className="input_select_custom_importa_usuario">
                                  <Select
                                    placeholder={this.props.translate["selecione_as_turmas"] || "Selecione as turmas"}
                                    itemRenderer={({ item, methods }) => (
                                      <div>
                                        {item.disabled ? (
                                          <div className="custom-control custom-checkbox">
                                            <input className="custom-control-input" type="checkbox" readOnly />
                                            <label className="custom-control-label">{item.name}</label>
                                          </div>
                                        ) : (
                                          <div style={{ display: "flex", alignItems: "center" }} className="custom-control custom-checkbox">
                                            <input
                                              checked={methods.isSelected(item)}
                                              className="custom-control-input"
                                              type="checkbox"
                                              readOnly
                                            />
                                            <label
                                              onClick={() => {
                                                if (item.type !== undefined && item.type !== "") {
                                                  methods.addItem(item)
                                                } else {
                                                  const sel = `.select_tt_bu_${item.id}_line_${index}`
                                                  $(sel).removeClass("flash")
                                                  setTimeout(() => { $(sel).addClass("animated").addClass("flash") }, 100)
                                                }
                                              }}
                                              className="custom-control-label"
                                            >
                                              {item.name}
                                            </label>
                                            <div style={{ marginLeft: "8px" }}>
                                              Tipo:
                                              <select
                                                className={`select_tt_bu_${item.id}_line_${index}`}
                                                value={item.type || ""}
                                                onChange={event => {
                                                  if (!event.target.value) return
                                                  item.type = event.target.value
                                                  this.setState({ _r: Date.now() })
                                                  const already = (row.classRoom || []).findIndex(x => String(x.id) === String(item.id))
                                                  if (already === -1) methods.addItem(item)
                                                }}
                                                style={{ boxShadow: "0px 1px 3px -2px #000", borderRadius: "4px", marginLeft: "6px", fontSize: "0.85rem" }}
                                              >
                                                <option value=""></option>
                                                {(window.app && window.app.state && window.app.state.permitions ? window.app.state.permitions : [{id:3,name:"Professor"},{id:4,name:"Aluno"},{id:6,name:"Diretor"}]).map((p, pi) => (
                                                  <option value={p.id} key={"perm_bu_" + index + "_" + pi}>{p.name}</option>
                                                ))}
                                              </select>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    )}
                                    labelField="name"
                                    values={row.classRoom || []}
                                    onChange={event => this.changeValue(index, "classRoom", event)}
                                    valueField="id"
                                    multi
                                    options={row.classRooms || this.props.state.classRoom || []}
                                  />
                                </div>
                              </td>
                              <td>
                                <i style={{ cursor: "pointer", color: "#d9534f" }} onClick={() => this.removeLine(index)} className="far fa-trash-alt"></i>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="mt-3 d-flex flex-wrap gap-2">
                      <Button color="secondary" className="mr-2" onClick={() => this.checkXlsxServer()} disabled={this.state.verifyingData}>
                        {this.props.translate["verificar_dados_atualizacao"] || "Verificar dados"}
                      </Button>
                      <Button color="primary" className="mr-2" onClick={() => this.applyUpdates()} disabled={!this.state.verificado || this.state.applying}>
                        {this.props.translate["aplicar_atualizacoes"] || "Aplicar atualizações"}
                      </Button>
                    </div>
                  </React.Fragment>
                )}
              </CardBody>
            </Card>
          </div>
        </Modal>
      </React.Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    translate: state.translate,
    user: state.user
  }
}

export default connect(mapStateToProps, {})(BulkUpdateUsersXlsx)
